export default {
      id: "link-usage",
      viewBox: "0 0 30 30",
      url: "/assets/" + "icons.svg#link",
      toString: function () {
        return this.url;
      }
    }